import {
  endOfMonth,
  format,
  startOfMonth,
  startOfYear,
  subDays,
  subMonths,
} from 'date-fns';

export type DatePresetId =
  | 'last7'
  | 'last30'
  | 'last90'
  | 'mtd'
  | 'lastMonth'
  | 'ytd'
  | 'last12m';

export type DateRange = { from: string; to: string; label: string };

export const DATE_PRESETS: { id: DatePresetId; label: string; range: () => DateRange }[] = [
  {
    id: 'last7',
    label: 'Last 7 days',
    range: () => {
      const to = new Date();
      const from = subDays(to, 6);
      return { from: fmt(from), to: fmt(to), label: 'Last 7 days' };
    },
  },
  {
    id: 'last30',
    label: 'Last 30 days',
    range: () => {
      const to = new Date();
      const from = subDays(to, 29);
      return { from: fmt(from), to: fmt(to), label: 'Last 30 days' };
    },
  },
  {
    id: 'last90',
    label: 'Last 90 days',
    range: () => {
      const to = new Date();
      const from = subDays(to, 89);
      return { from: fmt(from), to: fmt(to), label: 'Last 90 days' };
    },
  },
  {
    id: 'mtd',
    label: 'Month to date',
    range: () => {
      const to = new Date();
      const from = startOfMonth(to);
      return { from: fmt(from), to: fmt(to), label: 'Month to date' };
    },
  },
  {
    id: 'lastMonth',
    label: 'Last month',
    range: () => {
      const end = endOfMonth(subMonths(new Date(), 1));
      const start = startOfMonth(subMonths(new Date(), 1));
      return { from: fmt(start), to: fmt(end), label: 'Last month' };
    },
  },
  {
    id: 'ytd',
    label: 'Year to date',
    range: () => {
      const to = new Date();
      const from = startOfYear(to);
      return { from: fmt(from), to: fmt(to), label: 'Year to date' };
    },
  },
  {
    id: 'last12m',
    label: 'Last 12 months',
    range: () => {
      const to = new Date();
      const from = subDays(to, 364);
      return { from: fmt(from), to: fmt(to), label: 'Last 12 months' };
    },
  },
];

function fmt(d: Date): string {
  return format(d, 'yyyy-MM-dd');
}

export function presetById(id: DatePresetId): DateRange {
  return DATE_PRESETS.find((p) => p.id === id)!.range();
}
